import { ArrangementTypes as BaseArrangementTypes } from '@sagano/share/stores';

export class ArrangementTypes extends BaseArrangementTypes {}

export default new ArrangementTypes();
